import { render, staticRenderFns } from "./AlertHandler.vue?vue&type=template&id=e0a2c63e&"
import script from "./AlertHandler.vue?vue&type=script&lang=ts&"
export * from "./AlertHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports